import React from "react";
// Components
import VerifyToken from "../../config/verifyToken";
import { Main } from "../generalStyle";
import Header from "../../components/header";
import StickyLogo from "../../components/stickyLogo";
import Settings from "../../components/settings"

const SettingsView = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <Settings />
    </Main>
  </>
);

export default SettingsView;
